/* src/app/modules/user/partnersequity/related-companies/related-companies-delete.component.css */
/*# sourceMappingURL=related-companies-delete.component.css.map */
